
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import ProcessoVendasModal from './ProcessoVendasModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoProcessoVendas from '@/servicos/Cadastros/Vendas/ServicoProcessoVendas';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import storeSistema from '@/store/storeSistema';

export default defineComponent({
  name: 'ProcessoVendas',
  components: {
    TelaPadraoCrud,
    ProcessoVendasModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoSistema = new ServicoSistema();
    const servicoProcessoVendas = new ServicoProcessoVendas();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do processo de vendas';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Nome', dataIndex: 'nome', key: 'Nome', position: 2, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao, width: 300,
      },
      {
        title: 'Responsável', dataIndex: 'nomeResponsavel', key: 'NomeResponsavel', position: 3, visible: true, align: 'left', width: 200,
      },
      {
        title: 'Ativo', dataIndex: 'ativo', key: 'Ativo', position: 4, visible: true, align: 'center', fixed: 'right', width: 50, customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 50, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function atualizarMenuSistema() {
      const menus = await servicoSistema.obterMenu(storeSistema.getters.codigoEmpresaOperacao());
      storeSistema.mutations.atualizarMenus(menus);
    }

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoProcessoVendas,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      atualizarMenuSistema,
      refCrud,
    };
  },
});
